import React from "react"
import Shelf from "./Shelf"
import Camera from "./Camera"
import StatusPin from "./StatusPin"

const isEmpty = (value) =>
  !value || (typeof value === "object" && Object.keys(value).length === 0)

export default function Cell({
  item,
  corner = "",
  centered = false,
  contentType = "",
  gondolaType = "",
}) {
  const isSmartCooler = gondolaType?.toLowerCase()?.includes("smart cooler")
  const shelf = isSmartCooler ? null : item?.shelf
  const camera = item?.camera
  const rightCamera = item?.rightCamera
  const hasShelf = !isEmpty(shelf)
  const hasCamera = !isEmpty(camera)
  const hasRightCamera = !isEmpty(rightCamera)
  const cornerClass = corner ? ` corner-${corner}` : ""

  const isRightCorner =
    corner === "top-right" || corner === "bottom-right" || (!hasCamera && hasRightCamera)
  const isTop = corner.includes("top") || contentType.startsWith("H")
  const actualCorner = isRightCorner
    ? isTop
      ? "top-right"
      : "bottom-right"
    : isTop
    ? "top-left"
    : "bottom-left"

  if (!hasShelf && !hasCamera && !hasRightCamera) {
    return <div className={`cell${cornerClass}`} />
  }

  // Corner-only cells (smart cooler head/foot)
  if (!hasShelf && (hasCamera || hasRightCamera)) {
    if (hasCamera && hasRightCamera) {
      return (
        <div className="cell cell-dual-corner">
          <Camera data={camera} type={contentType + "CL"} />
          <Camera data={rightCamera} type={contentType + "CR"} />
        </div>
      )
    }
    return (
      <div className={`cell corner-${actualCorner}`}>
        <Camera
          data={hasCamera ? camera : rightCamera}
          type={contentType + (isRightCorner ? "CR" : "CL")}
        />
      </div>
    )
  }

  return (
    <div className={`cell cell-device${cornerClass}`}>
      <div className={`device-top${centered ? " centered" : ""}`}>
        {hasCamera ? <Camera data={camera} type="CM" /> : <span />}
      </div>
      {hasShelf ? (
        <Shelf data={shelf} centered={centered} showPin={true} type="SCM" />
      ) : null}
    </div>
  )
}
